import Route from '@ember/routing/route';

const QUERY_PARAMS = [
  'type',
].reduce((accum, param) => {
  accum[param] = { replace: true };
  return accum;
}, { });

class AdminLegalRoute extends Route {

  get queryParams() {
    return QUERY_PARAMS;
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadLegals.cancelAll({ resetState: true });
    }
  }
}

export default AdminLegalRoute;
